import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem
} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'

const AdvertisementMenuActions = ({ advertisement, onPublish, onDelete, busy }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const closeMenu = () => setAnchorEl(null)
  const menuId = `advertisement-actions-${advertisement.id}`

  return (
    <React.Fragment>
      <IconButton
        aria-label='Akcje reklamy'
        aria-controls={anchorEl ? menuId : undefined}
        aria-haspopup='true'
        aria-expanded={Boolean(anchorEl)}
        disabled={busy}
        onClick={event => setAnchorEl(event.currentTarget)}
        style={{ padding: 2 }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        {advertisement.status === 'draft' && (
          <MenuItem
            disabled={busy}
            onClick={() => {
              closeMenu()
              onPublish(advertisement.id)
            }}
          >
            Publikuj
          </MenuItem>
        )}
        <MenuItem
          disabled={busy}
          onClick={() => {
            closeMenu()
            setConfirmDelete(true)
          }}
        >
          Usuń
        </MenuItem>
      </Menu>
      <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
        <DialogTitle>Usunięcie reklamy</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Czy usunąć reklamę "${advertisement.name || ''}"?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDelete(false)}>Anuluj</Button>
          <Button
            color='secondary'
            disabled={busy}
            onClick={() => {
              setConfirmDelete(false)
              onDelete(advertisement.id)
            }}
          >
            Usuń
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

AdvertisementMenuActions.propTypes = {
  advertisement: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  onPublish: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  busy: PropTypes.bool
}

export default AdvertisementMenuActions
